module.exports = __webpack_public_path__ + "static/media/destination.3928ecc2.svg";